import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useDashboardSitesQueryQuery, useToggleDashboardSiteMutationMutation } from '../../generated/graphql';
import Switch from '@mui/material/Switch';
import { useUserContext } from '../../contexts/user-context';

export default function NewSitesDashboard() {
    const { data, loading, error, refetch } = useDashboardSitesQueryQuery({
        fetchPolicy: 'network-only',
    });
    const [toggleDashboardSite] = useToggleDashboardSiteMutationMutation({
        onCompleted: () => {
            refetch();
        },
    });
    const userContext = useUserContext();

    const handleToggle = async (id: string, currentValue: boolean) => {
        try {
            await toggleDashboardSite({
                variables: {
                    id,
                    is_dashboard_site: !currentValue,
                },
            });
        } catch (err) {
            console.error('Error toggling dashboard site:', err);
        }
    };
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <TableContainer component={Paper}>
            <Table aria-label="dashboard sites table">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>Site Name</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Format</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Region</TableCell>
                        {userContext.hasPermission('sites.toggle_dashboard_sites') && <TableCell sx={{ fontWeight: 'bold' }} align="right">Dashboard Site</TableCell>}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data?.sites.map((site: any) => (
                        <TableRow
                            key={site.id}
                            sx={{
                                '&:last-child td, &:last-child th': { border: 0 },
                                height: '30px'
                            }}
                        >
                            <TableCell component="th" scope="row" sx={{ padding: '4px 16px' }}> 
                                {site.externalLink ? (
                                    <a href={site.externalLink} target="_blank" rel="noopener noreferrer">
                                        {site.name}
                                    </a>
                                ) : (
                                    'No Link'
                                )}
                            </TableCell>

                            <TableCell component="th" scope="row" sx={{ padding: '4px 16px' }}> 
                                {site.siteStructure.name || 'N/A'}
                            </TableCell>
                            <TableCell component="th" scope="row" sx={{ padding: '4px 16px' }}> 
                                {site.region.name || 'N/A'}
                            </TableCell>
                            {userContext.hasPermission('sites.toggle_dashboard_sites') && (
                                <TableCell align="right" sx={{ padding: '4px 16px' }}> 
                                    <Switch
                                        checked={site.is_dashboard_site}
                                        color="primary"
                                        onChange={() => handleToggle(site.id, site.is_dashboard_site)}
                                    />
                                </TableCell>
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
